<template>
  <div style="width: 100%">
    <div
      style="
        position: absolute;
        width: 400px;
        top: 10px;
        left: 10px;
        background-color: rgba(5, 25, 65, 0.5);
        border: solid 1px rgba(95, 125, 165, 0.6);
        border-radius: 20px;
      "
    >
      <div style="padding: 8px 10px">
        <el-button
          type="warning"
          icon="el-icon-d-arrow-left"
          circle
          size="small"
          style="pointer-events: auto"
          @click="$router.push('/screen28896')"
        />
        <span style="color: #c9d3fc"> {{ name }}</span>
        <div
          style="
            font-size: 12px;
            color: #c9d3fc;
            line-height: 150%;
            padding: 0 0 0 38px;
          "
        >
          {{ desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import map from './DetailMap.js'
export default {
  data() {
    return {
      name: null, //乡镇的名称
      desc: null, //乡镇的介绍
    }
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    map.start(this, this.$route.params.id)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
    map.destroy()
  },
  methods: {
    setName(val) {
      this.name = val
    },
    setDesc(val) {
      this.desc = val
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/screen28896/map-zone/mask/detail.vue